import {EventBus} from "../../../../common/ts/events/EventBus";
import {
    GetNumberOfListingRequestEvent,
    GetNumberOfListingsAjax,
    ListingsFilteringResponseEvent
} from "../../core/filters/GetNumberOfListingsAjax";
import {userSearchFormData} from "../../../../mitula/ts/serp/filters/filterFormData";


// const SHOW_RESULTS_BUTTON_ID = 'show-results-button'

export class GetNumberOfListingSubscriber {
    private readonly eventBus: EventBus;

    constructor(eventBus: EventBus) {
        this.eventBus = eventBus;
    }

    init() {
        this.eventBus.subscribeWithId(GetNumberOfListingRequestEvent.TYPE, {
            id: 'get-number-of-listing-request-subscriber',
            callback: (event) => {
                const {payload}: GetNumberOfListingRequestEvent = event as GetNumberOfListingRequestEvent;
                this.getNumberOfListings(payload.buttonId)
            }
        });
        this.eventBus.subscribeWithId(ListingsFilteringResponseEvent.TYPE, {
            id: 'listings-filtering-response-subscriber',
            callback: (event) => {
                const {payload}: ListingsFilteringResponseEvent = event as ListingsFilteringResponseEvent;
                this.showResultsOnButton(payload.numberOfFilteredResults, payload.buttonId)
                this.showResultsOnHeader(payload.numberOfFilteredResults)
            }
        });
    }

    private getNumberOfListings(buttonId: string) {
        new GetNumberOfListingsAjax(this.eventBus).execute(userSearchFormData(buttonId))
    }

    private showResultsOnButton(numberOfFilteredResults: string, buttonId: string): void {
        const numberOfListingsFilteredElement = document.getElementById(buttonId);
        if (numberOfListingsFilteredElement) {
            numberOfListingsFilteredElement.textContent = numberOfFilteredResults
        }
    }

    private showResultsOnHeader(numberOfFilteredResults: string): void {
        const resultsCounters = document.querySelectorAll('.results-counter')
        if (resultsCounters) {
            resultsCounters.forEach((element: Element) => {
                const textContent = element.textContent;
                element.textContent = this.replaceNumberInText(
                    textContent, numberOfFilteredResults);
            });
        }
    }

    private replaceNumberInText(text: string | null, numberOfResults: string): string {
        if (!text) return '';
        return text.replace(/\d{1,3}(?:[,. ]\d{3})*/g, numberOfResults.toString());
    }

}